/**
 * Functions to operate on dynamically running javascript modules with an
 * initialize() function entrypoint.
 *
 * @module component/global/lib
 */

// Global variables
import * as constant from './constant.js';

// global is the global object. Once transpiled, this should be window in the
// browser environment, and global in the node environment
// TODO: handle error condition when given a non-module for module arg
function define_module_globals(global, module) {
    for (let [name, val] of Object.entries(module.global_vars)) {
        global[name] = val;
    }
}

function define_globals(global, all_modules) {
    for (const module of all_modules) {
        define_module_globals(global, module);
    }
}

function init_modules(global, all_modules) {
    for (const module of Array.from(all_modules)) {
        module.initialize(global);
    }
}

/**
 * Initialize all global modules
 * @param {Window} global - The global object (window in browser context)
 * @param {Object[]} all_modules - Array of module objects to initialize
 */
export function initialize(global, all_modules) {
    // Define global constants
    let constant_mod = {
        MODULE_NAME: 'global_constant',
        global_vars: constant,
    };
    define_module_globals(global, constant_mod);

    // Define any global constants defined by modules in all_modules
    define_globals(global, all_modules);
    init_modules(global, all_modules);
}

// Initialize
// Note: global is the global object. Once transpiled, this should be window in
// the browser environment, and global in the node environment
// initialize(global, __all__);
